// extracted by mini-css-extract-plugin
module.exports = {"info":"SectInfo-module--info--3A_Cw","transparent":"SectInfo-module--transparent--15FOg"};